// components/Courses/CoursesGrid.js
import React from "react";
import CourseCard from "./CourseCard";

const CoursesGrid = ({ courses, onDelete, canManage }) => {
  if (!courses.length)
    return <div className="text-muted text-center my-5">No courses found.</div>;

  return (
    <div className="row g-4">
      {courses.map((course) => (
        <div key={course._id} className="col-12 col-md-6 col-lg-4">
          <CourseCard course={course} onDelete={onDelete} canManage={canManage} />
        </div>
      ))}
    </div>
  );
};

export default CoursesGrid;
